//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: '',
  data: function data() {
    return {
      list: [{
        routerName: 'dynamic',
        title: "公司动态",
        subtitle: "COMPANY NEWS",
        image: require('../../assets/images/dynamic/bg.png')
      }, {
        routerName: 'about',
        title: "关于我们",
        subtitle: "ABOUT US",
        image: require('../../assets/images/about/bg.png')
      }, {
        routerName: 'contact',
        title: "联系我们",
        subtitle: "CONTACT US",
        image: require('../../assets/images/contact/bg.png')
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {}
};